<template>
	<!-- Begin Page Content -->
  <div class="container-fluid">

    <!-- Page Heading -->
    <h1 class="h3 mb-2 text-gray-800">Сонгосон хичээлүүд</h1>
    <div class="row" v-if="lessons!=null && lessons.length>0">

      <div class="col-lg-4" v-for="(lesson) in lessons" v-bind:key="lesson.id">
        <div class="card-deck">
          <div class="card shadow mb-4">
            <div class="card-header py-3">
              <h6 class="m-0 font-weight-bold text-primary">{{lesson.name}}</h6>
            </div>
            <div class="card-body">
              <p v-if="lesson.description!=null">{{lesson.description.substring(0,200)}}...</p>
              <button class="btn btn-primary" @click="goDetail(lesson)">Үзэх</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if='loading==false' class="text-center alert alert-info">Та одоогоор ямар нэгэн хичээл сонгоогүй байна.</div>
    <div v-if="loading==true && lessons==null || (lessons!=null && lessons.length==0)" style="position:fixed;z-index:10000000; top:45%;left:45%">
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-light" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require('../firebaseConfig.js')
import Vue from 'vue'
import { mapState } from 'vuex'
export default {
  name: "LessonGrid",
  data() {
    return {
      msg: "Hellow",
      lessons: [],
      trending:{
        content:[]
      },
      loading: false
    };
  },
  created() {
    
      this._getLessons();

    
  },
  computed: {
        ...mapState(['currentUser'])
  },
   methods: {
    _getLessons(){
		   var _this = this;
       var vm = this;
       if(this.currentUser!=null){
         
         fb.usersCollection.doc(this.currentUser.uid).get().then(userData=>{
           this.loading=true;
           if(userData!=null && userData.exists && userData.data().role!=null && userData.data().role=='student' && userData.data().customer!=null){
             userData.data().customer.get().then(stData=>{
               if(stData!=null && stData.exists){
                 stData.ref.collection("lessonList").onSnapshot(querySnapshot=>{
                    this.lessons = [];
                    querySnapshot.forEach(function(doc) {
                      if(doc.exists && doc.data().lessonRef!=null){
                        doc.data().lessonRef.get().then(lessonDoc=>{
                          let lesson=lessonDoc.data();
                          lesson.id=lessonDoc.id;
                          // if(lesson.published==true)
                            _this.lessons.push(lesson);
                          this.loading=false;
                        });
                      }
                      
                    });
                    
                 })
               }
             })
           }
           else
            this.loading=false;
         })
      }
        
		},
		
        goDetail(lesson){
          this.$router.push({ name: 'LessonDetailPublic', params: { lessonId: lesson.id} })
        }

    },
};
</script>